const variables = {
  cta: {
    variant: 'secondary',
  },
};

export default variables;
